import type { SVGProps } from "react";
import * as React from "react";
const SvgMailClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22 14h-2V8.238l-7.928 7.1L4 8.216V18h11v2H2V4h20v10ZM4.511 6l7.55 5.662L19.502 6H4.511Zm16.903 13 2.121 2.121-1.414 1.415L20 20.413l-2.121 2.121-1.415-1.414L18.587 19l-2.121-2.121 1.414-1.415L20 17.587l2.121-2.121 1.415 1.414L21.413 19Z"
    />
  </svg>
);
export default SvgMailClose;
